import React from 'react';
import PropTypes from 'prop-types';
import {colors} from './../../assets/theme';
import kmToMi from 'km-to-mi';

class Stats extends React.Component {   

    constructor(props){
        super(props);
    }
    componentWillMount(){ }
    
    componentDidMount(){ }

    render(){

        
        const getDistance = ()=>{
            if(!this.props.distance) return null;
            const distance = kmToMi(this.props.distance / 1000);

            return (
                <div>
                     &lt; {Math.ceil(distance)} miles away
                </div>
            )
        }


        return (
            <div className="Stats">
                <div className="distance">{getDistance()}</div>
                
                <div className="quantity">{this.props.quantity}</div>
                <div className="needed" >{(this.props.quantity)?'Needed':'All Welcome'}</div>
                
                <style jsx>{`
                    .distance {
                        text-align: right;
                        color:${colors.primaryHi};
                        font-size:12px;
                        font-weight:700;
                        white-space: nowrap;
                    }
                    .quantity  {
                        text-align: right;
                        color:${colors.primary};
                        font-size:28px;
                        font-weight:700;
                        white-space: nowrap;
                    }
                    .needed {
                        text-align: right;
                        color:${colors.primary};
                        font-size:12px;
                        font-weight:700;
                        white-space: nowrap;
                        text-transform: uppercase;
                    }
                    .Stats {}
                `}</style>
                
            </div>
        )
    }
}

Stats.propTypes = {
    
}

export default Stats;


// WEBPACK FOOTER //
// ./src/components/common/Stats.js